import { getField } from 'sprout-api-client/src/response/Post';
import { POST_FIELDS, POST_METRICS } from './properties';
import { asyncGetPosts } from '../helpers/posts-helpers';
var Posts = /** @class */ (function () {
    function Posts() {
        this.id = 'posts';
        this.alias = 'Posts';
    }
    Posts.prototype.getTableInfo = function () {
        return {
            id: this.id,
            alias: this.alias,
            columns: POST_FIELDS.map(function (c) { return c.column; }).concat(POST_METRICS.map(function (c) { return c.column; })),
        };
    };
    Posts.prototype.getData = function (connector, table, done) {
        asyncGetPosts({
            connector: connector,
            table: table,
            done: done,
            body: {
                start: connector.getStartDate(),
                end: connector.getEndDate(),
                fields: Posts.uniqueValues(POST_FIELDS.map(function (c) { return c.apiKey; })),
                metrics: POST_METRICS.map(function (c) { return c.apiKey; }),
            },
            rowsFormatter: function (response) {
                var rows = response.data.map(function (post) {
                    var result = new Map();
                    POST_FIELDS.forEach(function (field) {
                        var _a, _b;
                        var value = getField(post, field.apiKey);
                        if (value !== null && typeof value === 'object') {
                            if (field.postProcess === undefined) {
                                throw new Error('non-primitive fields must have a postProcess() hook');
                            }
                            result.set(field.column.id, field.postProcess(value));
                        }
                        else {
                            result.set(field.column.id, (_b = (_a = field.postProcess) === null || _a === void 0 ? void 0 : _a.call(field, value)) !== null && _b !== void 0 ? _b : value);
                        }
                    });
                    POST_METRICS.forEach(function (metric) {
                        var _a, _b, _c;
                        var value = (_a = post.metrics) === null || _a === void 0 ? void 0 : _a[metric.apiKey];
                        if (value) {
                            result.set(metric.column.id, (_c = (_b = metric.postProcess) === null || _b === void 0 ? void 0 : _b.call(metric, value)) !== null && _c !== void 0 ? _c : value);
                        }
                    });
                    return Object.fromEntries(result);
                });
                return rows;
            },
            requestProgressMessageFormatter: function (count) { return "Loaded ".concat(count.toLocaleString(), " posts"); },
        });
    };
    /**
     * Returns copy of Array<string> with duplicates removed
     * @param array
     * @private
     */
    Posts.uniqueValues = function (array) {
        return Object.keys(Object.fromEntries(array.map(function (v) { return [v, true]; })));
    };
    return Posts;
}());
export default Posts;
